import firebaseApp from "services/firebase";

const functions = firebaseApp.functions();

const exportClinicalNotePdfCallable = functions.httpsCallable(
  "exportClinicalNotePdf",
  { timeout: 60000 },
);

/**
 * Export a clinical note to PDF via Cloud Function.
 * @param {object} params
 * @param {string} params.templateName
 * @param {Array<{ key: string, title: string }>} params.sections
 * @param {Record<string, string>} params.noteSections
 * @param {string} [params.generatedAt] ISO timestamp
 * @returns {Promise<{ fileName: string, blob: Blob }>}
 */
export async function exportClinicalNotePdf({
  templateName,
  sections,
  noteSections,
  generatedAt,
}) {
  const payload = {
    templateName,
    sections,
    noteSections,
  };

  if (generatedAt) {
    payload.generatedAt = generatedAt;
  }

  const result = await exportClinicalNotePdfCallable(payload);
  const { pdfBase64, fileName, mimeType } = result?.data || {};

  if (!pdfBase64) {
    throw new Error("PDF export did not return file data.");
  }

  const binary = atob(pdfBase64);
  const bytes = new Uint8Array(binary.length);
  for (let i = 0; i < binary.length; i += 1) {
    bytes[i] = binary.charCodeAt(i);
  }

  const blob = new Blob([bytes], {
    type: mimeType || "application/pdf",
  });

  return {
    fileName: fileName || "clinical-note.pdf",
    blob,
  };
}

/**
 * Trigger a browser download for a Blob.
 * @param {Blob} blob
 * @param {string} fileName
 */
export function downloadBlob(blob, fileName) {
  const url = URL.createObjectURL(blob);
  const anchor = document.createElement("a");
  anchor.href = url;
  anchor.download = fileName;
  anchor.click();
  URL.revokeObjectURL(url);
}
